/**
 * A gentle card that renders the AI-generated wellness advice. The text is
 * non-medical by construction (server prompt) and always closes with a vet
 * reminder shown below.
 */
export function AdviceCard({ advice, loading }) {
  if (loading) {
    return (
      <div className="space-y-3 rounded-portal bg-portal-card p-6 shadow-portal">
        <div className="shimmer h-4 w-3/4 rounded" />
        <div className="shimmer h-4 w-full rounded" />
        <div className="shimmer h-4 w-5/6 rounded" />
      </div>
    );
  }
  if (!advice) return null;

  // The model returns short paragraphs/lines; render each on its own row.
  const lines = String(advice).split('\n').map((l) => l.trim()).filter(Boolean);

  return (
    <div className="rounded-portal bg-portal-card p-6 shadow-portal">
      <div className="space-y-3 text-portal-ink">
        {lines.map((line, i) => (
          <p key={i} className="leading-relaxed">{line.replace(/^[-•]\s*/, '')}</p>
        ))}
      </div>
      <p className="mt-5 border-t border-portal-border pt-4 text-sm text-portal-ink-muted">
        Questi sono consigli generali sul benessere, non indicazioni mediche. Per qualsiasi dubbio sulla
        salute del tuo animale rivolgiti sempre al veterinario.
      </p>
    </div>
  );
}
